import { messages } from './messages';

const CellRender = (data, { isExpanded = false, isFirstRow = true } = {}) => {
  if (isExpanded && !isFirstRow) {
    return null;
  }
  return data?.status;
};

export const PickupStatus = {
  getMessageDescriptor: () => messages.pickupStatus,
  id: 'pickup-status',
  render: CellRender,
};
